<script setup lang="ts">
</script>

<template>
  <section class="flex relative justify-center items-center border border-neutral-200 rounded-b-lg pt-[70px] sm:pt-[94px] pb-[70px] sm:pb-[116px] bg-gradient-putih">
    <div class="shadow-inners" />
    <AnimateOnScroll animation="zoom-in">
      <h2 class="z-10 text-lg! text-center text-neutral-700 px-4 geistMonoFont">
        Rintisan Membangun Layanan Keuangan yang Memenuhi
        <br class="hidden sm:block">
        Kebutuhan untuk Bisnis Anda
      </h2>
    </AnimateOnScroll>
    <AnimateOnScroll animation="zoom-in" :delay="100" class="absolute -bottom-7.5 z-10 rounded-full bg-white">
      <div class="flex justify-center items-center bg-gradient-rintisan p-2.5 rounded-full size-15">
        <img
          class="size-5.5 object-contain"
          src="/images/icons/thick.png"
          alt="Check Icon"
        >
      </div>
    </AnimateOnScroll>
  </section>
</template>

<style scoped>
.bgBorderGradi {
  background: linear-gradient(135deg, rgba(235, 0, 139, 0.1) 0%, rgba(235, 0, 139, 0.05) 100%);
  border: 2px solid #eb008b;
}
</style>
